import { InventoryModule } from 'models/permission.model';
import { MAIN_STORE_ROUTE_KEYS } from './constants';

export type RouteModuleBinding = {
  screen: string;
  route: string;
  module: InventoryModule;
};

export const ROUTE_MODULE_BINDINGS: RouteModuleBinding[] = [
  {
    screen: 'inventory_stock',
    route: MAIN_STORE_ROUTE_KEYS.INVENTORY_STOCK,
    module: InventoryModule.InventoryManagement
  },
  {
    screen: 'inventory_store_items',
    route: MAIN_STORE_ROUTE_KEYS.INVENTORY_STORE_ITEMS,
    module: InventoryModule.InventoryManagement
  },
  {
    screen: 'main_store_minimum_stock_settings',
    route: MAIN_STORE_ROUTE_KEYS.MAIN_STORE_MINIMUM_STOCK_SETTINGS,
    module: InventoryModule.InventoryManagement
  },
  {
    screen: 'kitchen_inventory_stock',
    route: MAIN_STORE_ROUTE_KEYS.KITCHEN_INVENTORY_STOCK,
    module: InventoryModule.InventoryManagement
  },
  {
    screen: 'stock_prep_team',
    route: MAIN_STORE_ROUTE_KEYS.STOCK_PREP_TEAM,
    module: InventoryModule.InventoryManagement
  },
  {
    screen: 'stock_brand_chef_team',
    route: MAIN_STORE_ROUTE_KEYS.STOCK_BRAND_CHEF_TEAM,
    module: InventoryModule.InventoryManagement
  },
  {
    screen: 'kitchen_minimum_stock_settings',
    route: MAIN_STORE_ROUTE_KEYS.KITCHEN_MINIMUM_STOCK_SETTINGS,
    module: InventoryModule.InventoryManagement
  },
  {
    screen: 'procurement',
    route: MAIN_STORE_ROUTE_KEYS.PROCUREMENT,
    module: InventoryModule.Procurement
  },
  {
    screen: 'kitchen_procurement',
    route: MAIN_STORE_ROUTE_KEYS.KITCHEN_PROCUREMENT,
    module: InventoryModule.KitchenRequisition
  },
  {
    screen: 'executive_procurements',
    route: MAIN_STORE_ROUTE_KEYS.EXECUTIVE_PROCUREMENTS,
    module: InventoryModule.Procurement
  },
  {
    screen: 'transfer',
    route: MAIN_STORE_ROUTE_KEYS.TRANSFER,
    module: InventoryModule.MainStoreTransfer
  },
  {
    screen: 'kitchen_transfer',
    route: MAIN_STORE_ROUTE_KEYS.KITCHEN_TRANSFER,
    module: InventoryModule.KitchenStoreTransfer
  },
  {
    screen: 'item_requests',
    route: MAIN_STORE_ROUTE_KEYS.ITEM_REQUESTS,
    module: InventoryModule.KitchenRequisition
  },
  {
    screen: 'excess_returns',
    route: MAIN_STORE_ROUTE_KEYS.EXCESS_RETURNS,
    module: InventoryModule.WastageReport
  },
  {
    screen: 'kitchen_manage_item_requests',
    route: MAIN_STORE_ROUTE_KEYS.KITCHEN_MANAGE_ITEM_REQUESTS,
    module: InventoryModule.KitchenRequisition
  },
  {
    screen: 'kitchen_manage_excess_returns',
    route: MAIN_STORE_ROUTE_KEYS.KITCHEN_MANAGE_EXCESS_RETURNS,
    module: InventoryModule.WastageReport
  },
  {
    screen: 'kitchen_manage_prep_team_requests',
    route: MAIN_STORE_ROUTE_KEYS.KITCHEN_MANAGE_PREP_TEAM_REQUESTS,
    module: InventoryModule.KitchenRequisition
  },
  {
    screen: 'prep_requests',
    route: MAIN_STORE_ROUTE_KEYS.PREP_REQUESTS,
    module: InventoryModule.KitchenRequisition
  },
  {
    screen: 'manage_requests',
    route: MAIN_STORE_ROUTE_KEYS.MANAGE_REQUESTS,
    module: InventoryModule.KitchenRequisition
  },
  {
    screen: 'waste_report',
    route: MAIN_STORE_ROUTE_KEYS.WASTE_REPORT,
    module: InventoryModule.WastageReport
  },
  {
    screen: 'kitchen_waste_report',
    route: MAIN_STORE_ROUTE_KEYS.KITCHEN_WASTE_REPORT,
    module: InventoryModule.WastageReport
  },
  {
    screen: 'manage_meals',
    route: MAIN_STORE_ROUTE_KEYS.MANAGE_MEALS,
    module: InventoryModule.ItemConversion
  },
  {
    screen: 'ingredient_list',
    route: MAIN_STORE_ROUTE_KEYS.INGREDIENT_LIST,
    module: InventoryModule.InventoryManagement
  },
  {
    screen: 'excel_meal_configuration',
    route: MAIN_STORE_ROUTE_KEYS.EXCEL_MEAL_CONFIGURATION,
    module: InventoryModule.ItemConversion
  },
  {
    screen: 'excel_prep_configuration',
    route: MAIN_STORE_ROUTE_KEYS.EXCEL_PREP_CONFIGURATION,
    module: InventoryModule.ItemConversion
  },
  {
    screen: 'base_meals',
    route: MAIN_STORE_ROUTE_KEYS.BASE_MEALS,
    module: InventoryModule.IngredientMapping
  },
  {
    screen: 'cost_settings',
    route: MAIN_STORE_ROUTE_KEYS.COST_SETTINGS,
    module: InventoryModule.ItemConversion
  },
  {
    screen: 'excel_meal_pricing',
    route: MAIN_STORE_ROUTE_KEYS.EXCEL_MEAL_PRICING,
    module: InventoryModule.ItemConversion
  },
  {
    screen: 'payment_tracker',
    route: MAIN_STORE_ROUTE_KEYS.PAYMNET_TRACKER,
    module: InventoryModule.PaymentModule
  },
  {
    screen: 'vendors',
    route: MAIN_STORE_ROUTE_KEYS.VENDORS,
    module: InventoryModule.Procurement
  },
  {
    screen: 'trash',
    route: MAIN_STORE_ROUTE_KEYS.TRASH,
    module: InventoryModule.InventoryManagement
  },
  {
    screen: 'manage_users',
    route: MAIN_STORE_ROUTE_KEYS.MANAGE_USERS,
    module: InventoryModule.User
  },
  {
    screen: 'manage_roles',
    route: MAIN_STORE_ROUTE_KEYS.MANAGE_ROLES,
    module: InventoryModule.Role
  }
];

const SORTED_ROUTE_MODULE_BINDINGS = [...ROUTE_MODULE_BINDINGS].sort(
  (a, b) => b.route.length - a.route.length
);

const normalizeToken = (value?: string) => {
  const normalized = String(value ?? '')
    .trim()
    .toLowerCase()
    .replace(/[\s-]+/g, '_');

  if (normalized === 'inventory_managment') {
    return 'inventory_management';
  }

  return normalized;
};

const normalizePath = (path: string) => {
  if (!path) return '';
  return path.endsWith('/') && path.length > 1 ? path.slice(0, -1) : path;
};

const isPathWithin = (pathname: string, route: string) => {
  const path = normalizePath(pathname);
  const protectedRoute = normalizePath(route);
  if (!path || !protectedRoute) return false;
  return path === protectedRoute || path.startsWith(`${protectedRoute}/`);
};

export const getRouteModuleBinding = (pathname: string): RouteModuleBinding | undefined => {
  return SORTED_ROUTE_MODULE_BINDINGS.find((binding) => isPathWithin(pathname, binding.route));
};

export const getModuleScreenBindings = (
  moduleName: InventoryModule | string
): RouteModuleBinding[] => {
  const normalizedModuleName = normalizeToken(moduleName);
  if (!normalizedModuleName) return [];

  return ROUTE_MODULE_BINDINGS.filter(
    (binding) => normalizeToken(binding.module) === normalizedModuleName
  );
};

export const getModuleScreenRoutes = (moduleName: InventoryModule | string): string[] => {
  return getModuleScreenBindings(moduleName).map((binding) => binding.route);
};
